import baseUrl from "../Api";
import { getlocation, trackingdata } from "../services/site";

const dotracking = async function (ftype, fid, fpage, tid,mid) {
  try {
    const response = await fetch("https://geolocation-db.com/json/");
    if (!response.ok) {
    //   console.error(
    //     "Geolocation API error:",
    //     response.status,
    //     response.statusText
    //   );
      return;
    }
    const res = await response.json();
    const temp = new FormData();
    if (res.IPv4 !== null) {
      temp.append("internet_ip_address_frontend", res.IPv4);
      temp.append("school_funder_group", ftype);
      temp.append("school_funder_group_id", fid);
      temp.append("school_funder_group_uid", mid);

      if (baseUrl == "https://sah.sportzvillage.com/dev/backend/api") {
        temp.append(
          "server_ip_address_frontend",
          "https://sah.sportzvillage.com"
        );
      } else if (
        baseUrl == "https://sportingbharat.com/lmp-dev/dev/backend/api"
      ) {
        temp.append("server_ip_address_frontend", "https://sportingbharat.com");
      }
      temp.append("location_city_frontend", res.city);
      temp.append("location_region_frontend", res.state);
      temp.append("location_county_frontend", res.country_name);
      temp.append("latitude_frontend", res.latitude);
      temp.append("longitude_frontend", res.longitude);
      temp.append("user_agent_frontend", navigator.userAgent);
      temp.append("current_page", fpage);
      temp.append("tournament_id", tid);
    } else {
      temp.append("internet_ip_address_frontend", "");
      temp.append("school_funder_group", ftype);
      temp.append("school_funder_group_id", fid);
      temp.append("school_funder_group_uid", mid);

      if (baseUrl == "https://sah.sportzvillage.com/dev/backend/api") {
        temp.append(
          "server_ip_address_frontend",
          "https://pathwayz.sportzvillage.com/"
        );
      } else if (
        baseUrl == "https://sportingbharat.com/lmp-dev/dev/backend/api"
      ) {
        temp.append("server_ip_address_frontend", "https://sportingbharat.com");
      }
      temp.append("location_city_frontend", "");
      temp.append("location_region_frontend", "");
      temp.append("location_county_frontend", "");
      temp.append("latitude_frontend", "");
      temp.append("longitude_frontend", "");
      temp.append("user_agent_frontend", navigator.userAgent);
      temp.append("current_page", fpage);
      temp.append("tournament_id", tid);
    }

    trackingdata(temp).then((response) => {
      if (response.status === true) {
      }
    });
  } catch (error) {
    // console.log('Error in dotracking:', error);
    const temp = new FormData();
    temp.append("internet_ip_address_frontend", "");
    temp.append("school_funder_group", ftype);
    temp.append("school_funder_group_id", fid);
    temp.append("school_funder_group_uid", mid);

    if (baseUrl == "https://sah.sportzvillage.com/dev/backend/api") {
      temp.append(
        "server_ip_address_frontend",
        "https://pathwayz.sportzvillage.com/"
      );
    } else if (
      baseUrl == "https://sportingbharat.com/lmp-dev/dev/backend/api"
    ) {
      temp.append("server_ip_address_frontend", "https://sportingbharat.com");
    }
    temp.append("location_city_frontend", "");
    temp.append("location_region_frontend", "");
    temp.append("location_county_frontend", "");
    temp.append("latitude_frontend", "");
    temp.append("longitude_frontend", "");
    temp.append("user_agent_frontend", navigator.userAgent);
    temp.append("current_page", fpage);
    temp.append("tournament_id", tid);

    trackingdata(temp).then((response) => {
      if (response.status === true) {
      }
    });
  }
  //   getlocation().then((res) => {
  //     const temp = new FormData();
  //     if (res.IPv4 !== null) {
  //       temp.append("internet_ip_address_frontend", res.IPv4);
  //     } else {
  //       temp.append("internet_ip_address_frontend", "");
  //     }
  //     temp.append("school_funder_group", ftype);
  //     temp.append("school_funder_group_id", fid);
//   temp.append("school_funder_group_uid", mid);
  //     if (baseUrl == "https://sah.sportzvillage.com/dev/backend/api") {
  //       temp.append("server_ip_address_frontend", "https://sah.sportzvillage.com");
  //     } else if (
  //       baseUrl == "https://sportingbharat.com/lmp-dev/dev/backend/api"
  //     ) {
  //       temp.append("server_ip_address_frontend", "https://sportingbharat.com");
  //     }
  //     temp.append("location_city_frontend", res.city);
  //     temp.append("location_region_frontend", res.state);
  //     temp.append("location_county_frontend", res.country_name);
  //     temp.append("latitude_frontend", res.latitude);
  //     temp.append("longitude_frontend", res.longitude);
  //     temp.append("user_agent_frontend", navigator.userAgent);
  //     temp.append("current_page", fpage);
  //     temp.append("tournament_id", tid);

  //     // trackingdata(temp).then((response) => {
  //     //   if (response.status === true) {

  //     //   }
  //     // });
  //   });
};

export default dotracking;
